import di from 'di'

import defaultConfig from '@/js/config/config.default';
import developmentConfig from '@/js/config/config.development';
import stagingConfig from '@/js/config/config.staging';
import productionConfig from '@/js/config/config.production';
import testingConfig from '@/js/config/config.testing';

export default function(){

    const ENV = import.meta.env.MODE;

    let config = defaultConfig;
    let envConfig = {};

    if(ENV === 'development'){
        envConfig = developmentConfig;
    }
    else if(ENV === 'staging'){
        envConfig = stagingConfig;
    }
    else if(ENV === 'production'){
        envConfig = productionConfig;
    }
    else if(ENV === 'testing'){
        envConfig = testingConfig;
    }

    Object.assign(config, envConfig);
    di.set('config', config);
}